import React from 'react'

type Props = React.ComponentPropsWithoutRef<'a'>

/**
 * This is an <a> tag that will use LiveView's push state to navigate to the new page.
 *
 * It should probably be your default link element for all internal links.
 */
export function LiveLink({ children, ...props }: Props) {
  const dataAttrs =
    typeof props.href === 'string' && props.href.length > 0
      ? {
          'data-phx-link': 'redirect',
          'data-phx-link-state': 'push',
        }
      : {}

  return (
    <a {...dataAttrs} {...props}>
      {children}
    </a>
  )
}
